exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-checkbox-wrapper{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.ant-checkbox-indeterminate .ant-checkbox-inner:after{width:.8rem;height:.8rem}", ""]);

